interface ShareButtonProps {
  currentUrl: string;
  liters: number;
  priceNl: number;
  priceDe: number;
  distance: number;
  consumption: number;
  savedAmount: number;
}

export default function ShareButton({
  currentUrl,
  liters,
  priceNl,
  priceDe,
  distance,
  consumption,
  savedAmount,
}: ShareButtonProps) {
  const shareText = `Ik heb net een berekening gemaakt om te zien hoeveel ik kan besparen door te tanken in Duitsland in plaats van Nederland! 🇳🇱➡️🇩🇪\n\nBekijk het hier: ${currentUrl}?liters=${liters}&priceNl=${priceNl}&priceDe=${priceDe}&distance=${distance}&consumption=${consumption}&ref=share`;

  return (
    <div>
      <button
        onClick={() => navigator.clipboard.writeText(shareText)}
        className="bg-blue-500 text-white px-4 py-2 rounded"
      >
        Deel je berekening
      </button>
    </div>
  );
}
